export const MAIN_INFO = 'MAIN_INFO';
export const GET_CERTIFY_LINK_DELETE_DATA = 'GET_CERTIFY_LINK_DELETE_DATA'
export const GET_CERTIFY_LINK_DELETE_DATA_END = 'GET_CERTIFY_LINK_DELETE_DATA_END'


// WEBPACK FOOTER //
// ./src/constants/main.js